import { gql } from '@apollo/client';

export const UPDATE_ORG_ACTIVITY = gql`
  mutation updateOrgActivity($id: ID!) {
    updateOrgActivity(id: $id)
  }
`;
